import { render, staticRenderFns } from "./boxed.vue?vue&type=template&id=4c9d4aef&"
import script from "./boxed.vue?vue&type=script&lang=js&"
export * from "./boxed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports